import type { FAMDetails } from '../../models/membership/famDetails';
import { requests } from '../httpClient';

export const Fam = {
    getFAMDetails: (personId: string) => requests.get(`Fam/${personId}`),
    getFamSubscriptionsAsync: () => requests.get('Fam/Subscriptions'),
    getCurrentYear: () => requests.get(`Fam/CurrentYear`),
    getCurrentMembershipTypeAsync: () => requests.get(`Fam/CurrentMembershipType`),
    updateFamDetails: (data: FAMDetails) => requests.put(`Fam`, data),
    addFamDetails: (data: FAMDetails) => requests.post(`Fam`, data),
    createReEnrolBasketAsync: () => requests.post(`Fam/CreateReEnrolBasket`, {}),
    getFamExamDetailsAsync: () => requests.get(`Fam/Exams`),
    getCanUseDirectDebitMandateAsync: () => requests.get(`Fam/CanUseDirectDebitMandate`)
};
